import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import UIButton from 'UIComponents/button/UIButton';
import { ALL_PIPELINES_QUERY_PARAM } from '../../constants/CrmSearchConstants';
import { getCurrentOwnerId } from '../../selectors/ownersSelectors';
import { makeDealFilterGroupByOwnerQuery } from '../../utils/filters';
import { getFilteredDealsUrl } from '../../utils/urls';
import { trackReassignDealsForDeactivatedUser } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RepDetailError = ({
  isDealStageView
}) => {
  const ownerId = getCurrentOwnerId();
  return /*#__PURE__*/_jsx(EmptyState, {
    primaryContent: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "repDetail.deactivatedUserError.message"
      }), /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "reassign-open-deals",
        href: getFilteredDealsUrl(makeDealFilterGroupByOwnerQuery({
          id: ownerId
        }), ALL_PIPELINES_QUERY_PARAM // Show all pipelines when reassigning Open Deals
        ),
        onClick: () => trackReassignDealsForDeactivatedUser(true, isDealStageView),
        use: "secondary",
        className: "m-top-4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "repDetail.deactivatedUserError.button"
        })
      })]
    }),
    secondaryContent: /*#__PURE__*/_jsx(Illustration, {
      name: "empty-state-charts",
      width: 150
    }),
    secondaryContentWidth: 250,
    titleText: /*#__PURE__*/_jsx(Text, {
      as: "h4",
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "repDetail.deactivatedUserError.header"
      })
    })
  });
};
export default RepDetailError;